var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-choice-layout" }, [
    _c(
      "div",
      { class: _vm.classes },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm.thereAreNoResults
          ? _c(
              "div",
              { staticClass: "trbo-a-choice-layout__list__no-results" },
              [_vm._v(_vm._s(_vm.$t("wizard.noSearchResults")))]
            )
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isShowingLoadMoreButton
      ? _c(
          "div",
          { staticClass: "trbo-a-choice-layout__actions" },
          [
            _c("load-more-options-button", {
              attrs: { "is-disabled": _vm.isShowingAllOptions },
              on: {
                click: function ($event) {
                  return _vm.$emit("load-more-options")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }